export default "__VITE_ASSET__wtJGJM$$__"